/**
 * Created by tofael on 7/14/17.
 */
import React from 'react';
import {connect} from 'react-redux';
import {hashHistory} from 'react-router';
import api from '../utility/api';
import AdminForm from '../screens/create-admin';
import {asyncStart, asyncEnd, showFeedback} from '../actions/application';

class AdminCreator extends React.Component {

  constructor() {
    super(...arguments);
    this.state = {
      name: '',
      user_name: '',
      email: '',
      phone: '',
      photo: null,
      address_line_1: '',
      address_line_2: '',
      postal_code: '',
      city: '',
      account_type: 'provider',
      admin: false,
      super_admin: false,
      scheduler: false,
      rmg: false,
      role: '',
      create_admin: true
    };
  }

  dispatch(action) {
    this.props.dispatch(action());
  }

  displayFeedBack(message) {
    this.props.dispatch(showFeedback({message: message}));
  }

  handleSubmit(e) {
    e.preventDefault();

    const {admin, super_admin, scheduler, rmg} = this.state;

    if (!admin && !super_admin && !scheduler && !rmg) {
      this.dispatch(showFeedback.bind(null, 'Please select a role.'));
      return;
    }
    
    let adminInfo = {};
    Object.assign(adminInfo, this.state);
    delete adminInfo.create_admin;
    delete adminInfo.photo;    
    delete adminInfo.role;

    this.dispatch(asyncStart);
    api.createUser(adminInfo)
      .then(user => {
        if (this.state.photo) {
          let form_data = new FormData();
          form_data.append('photo', this.state.photo);
          form_data.append('userId', user.id);
          return api.updateAdminPhoto(form_data);
        }
        return user;
      })
      .then(user=>{
        this.dispatch(asyncEnd);
        hashHistory.push('user/' + user.id);
      })
      .catch(error => {
        this.dispatch(asyncEnd);
        this.props.dispatch(showFeedback({message: error.message}));
      })

  }

  selectRole() {
    const role = this.state.role;
    if (role === "admin") {
      this.setState({rmg:false});
      this.setState({admin:true});
      this.setState({scheduler:false});
    }
    else if(role === "scheduler") {
      this.setState({scheduler:true});
      this.setState({admin:false});
      this.setState({rmg:false});
    }
    else if(role === "rmg") {
      this.setState({rmg:true});
      this.setState({admin:false});
      this.setState({scheduler:false});
    }
  }

  handleChange(field, e) {
    this.setState({[field]: e.target.value});
  }

  onCheck(field, e, value) {
    this.setState({[field]: value});
  }

  onPhotoSelect(e) {
    let file = e.target.files[0];
    this.setState({photo: file});
  }

  handleSelect(field, e) {
    this.setState({[field]: e.target.value}, () => {
      this.selectRole()
    });
  }

  render() {
    const {name, user_name, email, phone, photo, address_line_1, address_line_2, postal_code, city, role, admin, super_admin, scheduler, create_admin} = this.state;
    const {isLoading} = this.props.application;

    return (
      <AdminForm
        name={name}
        city={city}
        role={role}
        admin={admin}
        photo={photo}
        phone={phone}
        email={email}
        scheduler={scheduler}
        isLoading={isLoading}
        user_name={user_name}
        postal_code={postal_code}
        super_admin={super_admin}
        create_admin={create_admin}
        address_line_1={address_line_1}
        address_line_2={address_line_2}
        onCheck={this.onCheck.bind(this)}
        handleChange={this.handleChange.bind(this)}
        handleSubmit={this.handleSubmit.bind(this)}
        handleSelect={this.handleSelect.bind(this)}
        onPhotoSelect={this.onPhotoSelect.bind(this)}
      />
    )
  }
}

function mapStateToProps(state) {
  return {
    application: state.application,
    user: state.user
  }
}

export default connect(mapStateToProps, null)(AdminCreator);


// WEBPACK FOOTER //
// ./src/containers/create-admin.js